/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type {
  CanConnectResponse,
  CreateRallySyncSessionRequest,
  CreateRallySyncSessionResponse,
  CreateRallyTestItemRequest,
  CreateRallyTestItemResponse,
  CreateRallyWebhookRequest,
  DeleteRallyWebhookRequest,
  GetRallyApiKeyResponse,
  GetRallyFieldsRequest,
  GetRallyFieldsResponse,
  GetRallyIssueTypesResponse,
  GetRallyIterationsRequest,
  GetRallyIterationsResponse,
  GetRallyKanbanConfigsRequest,
  GetRallyKanbanConfigsResponse,
  GetRallyPortfolioWorkitemTypesResponse,
  GetRallyProjectMappingResponse,
  GetRallyProjectsResponse,
  GetRallyReleaseRequest,
  GetRallyReleaseResponse,
  GetRallyReleasesRequest,
  GetRallyReleasesResponse,
  GetRallyTagsResponse,
  GetRallyTenantIdResponse,
  GetRallyTenantsResponse,
  GetRallyWebhooksResponse,
  NoData,
  SetRallyApiKeyRequest,
  SetRallyProjectMappingRequest,
  SetRallyTenantIdRequest,
} from "./models";
import {
  canConnectResponseSchema,
  createRallySyncSessionResponseSchema,
  createRallyTestItemResponseSchema,
  getRallyApiKeyResponseSchema,
  getRallyFieldsResponseSchema,
  getRallyIssueTypesResponseSchema,
  getRallyIterationsResponseSchema,
  getRallyKanbanConfigsResponseSchema,
  getRallyPortfolioWorkitemTypesResponseSchema,
  getRallyProjectMappingResponseSchema,
  getRallyProjectsResponseSchema,
  getRallyReleaseResponseSchema,
  getRallyReleasesResponseSchema,
  getRallyTagsResponseSchema,
  getRallyTenantIdResponseSchema,
  getRallyTenantsResponseSchema,
  getRallyWebhooksResponseSchema,
  noDataSchema,
} from "./schemas";

export class AlmconnectionRallyApiClient {
  constructor(private caller: ApiCaller) {}

  async canConnect(connectionId: string, timeout?: number): Promise<CanConnectResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.can_connect.get",
        variables: { connectionId: String(connectionId) },
      },
      "canConnect",
      {},
      { schema: canConnectResponseSchema, timeout },
    );
  }

  async getRallyApikey(connectionId: string, timeout?: number): Promise<GetRallyApiKeyResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.apikey.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyApikey",
      {},
      { schema: getRallyApiKeyResponseSchema, timeout },
    );
  }

  async setRallyApikey(
    payload: SetRallyApiKeyRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.apikey.set",
        variables: { connectionId: String(connectionId) },
      },
      "setRallyApikey",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getRallyTenantId(
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyTenantIdResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.tenant_id.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyTenantId",
      {},
      { schema: getRallyTenantIdResponseSchema, timeout },
    );
  }

  async setRallyTenantId(
    payload: SetRallyTenantIdRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.tenant_id.set",
        variables: { connectionId: String(connectionId) },
      },
      "setRallyTenantId",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getRallyTenants(connectionId: string, timeout?: number): Promise<GetRallyTenantsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.tenants.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyTenants",
      {},
      { schema: getRallyTenantsResponseSchema, timeout },
    );
  }

  async getRallyProjects(
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyProjectsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.projects.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyProjects",
      {},
      { schema: getRallyProjectsResponseSchema, timeout },
    );
  }

  async getRallyProjectMapping(
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyProjectMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.project_mapping.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyProjectMapping",
      {},
      { schema: getRallyProjectMappingResponseSchema, timeout },
    );
  }

  async setRallyProjectMapping(
    payload: SetRallyProjectMappingRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.project_mapping.set",
        variables: { connectionId: String(connectionId) },
      },
      "setRallyProjectMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getRallyIssueTypes(
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyIssueTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.issue_types.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyIssueTypes",
      {},
      { schema: getRallyIssueTypesResponseSchema, timeout },
    );
  }

  async getRallyPortfolioWorkitemTypes(
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyPortfolioWorkitemTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.portfolio_workitem_types.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyPortfolioWorkitemTypes",
      {},
      { schema: getRallyPortfolioWorkitemTypesResponseSchema, timeout },
    );
  }

  async getRallyKanbanConfigs(
    payload: GetRallyKanbanConfigsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyKanbanConfigsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.kanban_configs.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyKanbanConfigs",
      payload,
      { schema: getRallyKanbanConfigsResponseSchema, timeout },
    );
  }

  async getRallyTags(connectionId: string, timeout?: number): Promise<GetRallyTagsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.tags.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyTags",
      {},
      { schema: getRallyTagsResponseSchema, timeout },
    );
  }

  async getRallyIterations(
    payload: GetRallyIterationsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyIterationsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.iterations.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyIterations",
      payload,
      { schema: getRallyIterationsResponseSchema, timeout },
    );
  }

  async getRallyRelease(
    payload: GetRallyReleaseRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyReleaseResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.release.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyRelease",
      payload,
      { schema: getRallyReleaseResponseSchema, timeout },
    );
  }

  async getRallyReleases(
    payload: GetRallyReleasesRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyReleasesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.releases.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyReleases",
      payload,
      { schema: getRallyReleasesResponseSchema, timeout },
    );
  }

  async getRallyFields(
    payload: GetRallyFieldsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.fields.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyFields",
      payload,
      { schema: getRallyFieldsResponseSchema, timeout },
    );
  }

  async getRallyWebhooks(
    connectionId: string,
    timeout?: number,
  ): Promise<GetRallyWebhooksResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.webhooks.get",
        variables: { connectionId: String(connectionId) },
      },
      "getRallyWebhooks",
      {},
      { schema: getRallyWebhooksResponseSchema, timeout },
    );
  }

  async createRallyWebhook(
    payload: CreateRallyWebhookRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.webhooks.create",
        variables: { connectionId: String(connectionId) },
      },
      "createRallyWebhook",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async deleteRallyWebhook(
    payload: DeleteRallyWebhookRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.webhooks.delete",
        variables: { connectionId: String(connectionId) },
      },
      "deleteRallyWebhook",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async createRallyTestItem(
    payload: CreateRallyTestItemRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<CreateRallyTestItemResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.test_item.create",
        variables: { connectionId: String(connectionId) },
      },
      "createRallyTestItem",
      payload,
      { schema: createRallyTestItemResponseSchema, timeout },
    );
  }

  async createRallySyncSession(
    payload: CreateRallySyncSessionRequest,
    connectionId: string,
    piSessionId: string,
    timeout?: number,
  ): Promise<CreateRallySyncSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.rally.connections.${connectionId}.pi_sessions.${piSessionId}.sync_session.create",
        variables: { connectionId: String(connectionId), piSessionId: String(piSessionId) },
      },
      "createRallySyncSession",
      payload,
      { schema: createRallySyncSessionResponseSchema, timeout },
    );
  }
}
